/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum DoorstroomResultaat {
    DOORSTROOM = "Doorstroom",
    GESLAAGD = "Geslaagd",
    OPSTROOM = "Opstroom",
    AFSTROOM = "Afstroom",
    DOUBLURE = "Doublure",
    AFGEWEZEN = "Afgewezen",
    VO_VERLATER = "VO verlater",
    GEEN = "Geen"
}
